/* eslint-disable bam/no-react-unbound */
import $ from 'jquery';
import { isNil } from 'lodash';
import { x0 } from '../../../_helpers';
import {
  searchHeadClass,
  searchButtonClass,
  searchContainerHook,
  searchOpenButtonHook,
  searchCloseButtonHook,
  searchActiveToggle,
  searchOpenToggle,
  topAdvBannerId,
} from '../../../_helpers/constants';

export default class Search {
  constructor() {
    this.el = x0(searchButtonClass);
    this.topAdvBanner = null;
    this.boundToggleSearch = this.toggleSearch.bind(this);
    if (!this.el) return;
    this.init();
  }

  toggleSearch(e) {
    e.preventDefault();
    this.searchContainer = $(searchContainerHook);
    if (isNil(this.searchContainer) || this.searchContainer.length === 0) {
      return;
    }

    this.setTopMargin();

    $(this.searchContainer[0]).toggleClass(searchActiveToggle);
    $('body').toggleClass(searchOpenToggle);
  }

  setTopMargin() {
    this.topAdvBanner = x0(topAdvBannerId);
    if (!isNil(this.topAdvBanner)) {
      const topAdvBannerHeight = this.topAdvBanner.offsetHeight;
      const searchHead = x0(searchHeadClass);
      searchHead.style.marginTop = `${topAdvBannerHeight}px`;
    }
  }

  attachEvents() {
    //open search
    if (this.searchOpener) {
      this.searchOpener.addEventListener('click', this.boundToggleSearch);
    }
    if (this.searchCloser) {
      this.searchCloser.addEventListener('click', this.boundToggleSearch);
    }

    document.addEventListener('scroll', this.setTopMargin);
  }

  init() {
    this.searchOpener = x0(searchOpenButtonHook, this.el);
    this.searchCloser = x0(searchCloseButtonHook);

    this.attachEvents();
  }
}
